import { Center, Spinner } from '@chakra-ui/react';

export const PageSpinner = ({ fullHeight }: { fullHeight?: boolean }) => {
  return (
    <Center h={fullHeight ? '100vh' : ''} w={'100%'}>
      <Spinner size={'xl'} />
    </Center>
  );
};
